import { render, staticRenderFns } from "./ChatOrderProfileCard.vue?vue&type=template&id=4939efad&scoped=true&"
import script from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileCard.vue?vue&type=style&index=0&id=4939efad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939efad",
  null
  
)

export default component.exports